<template>
	<section class="flex flex-col items-center token-swap">
		<h1 class="text-center mb-0">Token Swap</h1>

		<Swap class="max-w-[500px] animate__animated animate__fadeIn" :key="key"></Swap>
	</section>
</template>

<script>
import Swap from "@/components/token/Swap.vue";

export default {
	name: "TokenSwap",
	components: {Swap},
	data() {
		return {
			key: 0,
		}
	},
	methods: {
		setPromoToken: function () {
			localStorage.setItem("swap:default_token_a", JSON.stringify({
				"address": "So11111111111111111111111111111111111111112",
				"metadata": "94Wqo4hAyrW2VouuX85b6tkbNtkyTYVz4uhUynaRGdtj",
				"name": "Wrapped SOL",
				"symbol": "SOL",
				"decimals": 9,
				"supply": 0,
				"uri": "",
				"image": "https://raw.githubusercontent.com/solana-labs/token-list/main/assets/mainnet/So11111111111111111111111111111111111111112/logo.png",
				"programID": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
				"verified": true,
				"amount": 0
			}))
			localStorage.setItem("swap:default_token_b", JSON.stringify({
				"address": "FLUXBmPhT3Fd1EDVFdg46YREqHBeNypn1h4EbnTzWERX",
				"name": "FluxBot",
				"symbol": "FLUXB",
				"decimals": 5,
				"supply": 0,
				"uri": "",
				"image": "https://bafybeiakyhwwesdvxpikjn4kyqddira3hjpjfcn26ycrrezt65bfa7r3gm.ipfs.nftstorage.link",
				"programID": "TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb",
				"verified": true,
				"amount": 0
			}))
			this.key++
		}
	}
}
</script>

<style scoped>

</style>